import './OnboardFinish.scss'

import React, {Component} from 'react';

import { push } from 'react-router-redux'

const OnboardFinish = ({children}) => {
  return (
    <div className="OnboardFinish">
    Finish
    </div>
  )
}

export default OnboardFinish
